import api from "./api";

export const getUserBehaviorProfile = async (userId) => {
    const res = await api.get(`/behavioranalytics/user/${userId}`);
    return res.data;
};

export default {
    getUserBehaviorProfile,
};